import { DashboardNotificationAction, DashboardNotificationActionType } from '@web/dashboard/types';

export const getNotificationActionByType = (
  actions: DashboardNotificationAction[],
  type: DashboardNotificationActionType
): DashboardNotificationAction | null => {
  return actions.find((a) => a.type === type) || null;
};
